import { calculateRideMetrics, type Ride, type RidePoint, type RideMetrics } from './ride';
import { isCuratedStructuresPath } from './structures-sample';
import { structuresDemoTelemetry } from './structures-demo-telemetry';

const cache = new WeakMap<Ride, { points: readonly RidePoint[]; metrics: RideMetrics; available: boolean }>();

/** Supplies shared overlay measurements without changing the source used by maps or export validation. */
export function traceTelemetry(ride: Ride) {
  const cached = cache.get(ride);
  if (cached) return cached;
  const telemetry = isCuratedStructuresPath(ride) ? structuresDemoTelemetry(ride.points) : {
    points: ride.points,
    metrics: ride.metrics ?? calculateRideMetrics(ride.points),
    available: ride.source !== 'synthetic',
  };
  cache.set(ride, telemetry);
  return telemetry;
}
